// packages/components/src/support-ai/ExecutionStep.tsx
import React from 'react';
import { CheckCircle2, AlertTriangle, Loader, ShieldAlert, CircleSlash, BrainCircuit } from 'lucide-react';
import { Badge } from '@dopomogai/ui';

export interface ExecutionStepData {
  id: string;
  name: string;
  status: 'completed' | 'in_progress' | 'pending' | 'intervention' | 'dependency_needed' | 'error';
  progress?: number;
  reason?: string;
  agent?: string; // MODIFIED: Agent attribution
}

const statusMap = {
  // ... (statusMap object remains the same)
  completed: { icon: <CheckCircle2 size={20} className="text-emerald-500" />, label: 'Completed', color: 'green' as const, },
  in_progress: { icon: <Loader size={20} className="text-blue-500 animate-spin" />, label: 'In Progress', color: 'blue' as const, },
  pending: { icon: <Loader size={20} className="text-slate-400" />, label: 'Pending', color: 'gray' as const, },
  intervention: { icon: <AlertTriangle size={20} className="text-amber-500" />, label: 'Intervention Needed', color: 'yellow' as const, },
  dependency_needed: { icon: <ShieldAlert size={20} className="text-purple-500" />, label: 'Dependency Needed', color: 'purple' as const, },
  error: { icon: <CircleSlash size={20} className="text-red-500" />, label: 'Error', color: 'red' as const, },
};

export const ExecutionStep: React.FC<{ step: ExecutionStepData }> = ({ step }) => {
  const { icon, label, color } = statusMap[step.status] || statusMap.pending;

  return (
    <div className="p-4 bg-white border-2 border-black rounded-lg flex items-center gap-4">
      <div className="flex-shrink-0">{icon}</div>
      <div className="flex-grow">
        <p className="font-bold text-slate-800">{step.name}</p>
        {/* MODIFIED: Render agent if it exists */}
        {step.agent && (
          <div className="flex items-center gap-1 mt-1 text-xs text-slate-500">
            <BrainCircuit size={12} />
            <span>by: {step.agent}</span>
          </div>
        )}
        {step.reason && <p className="text-xs text-slate-500 mt-0.5">{step.reason}</p>}
      </div>
      <div className="flex-shrink-0">
        <Badge text={step.progress ? `${label} (${step.progress}%)` : label} accentColor={color} />
      </div>
    </div>
  );
};